<template>

    <div class="starMgtList spackage padding-20 bgc box-shadow">

        <el-tabs v-model="active" @tab-click="handleClick">
            <el-tab-pane label="成员列表" name="memberList">
                <StarMgtDelis :message="message"></StarMgtDelis>
                <MemberList :message="message"></MemberList>
            </el-tab-pane>
            <el-tab-pane label="星球公告" name="planetNotes">
                <StarMgtDelis :message="message"></StarMgtDelis>
                <PlanetNotes :message="message"></PlanetNotes>
            </el-tab-pane>
            <el-tab-pane label="星球资料" name="planetData">
                <StarMgtDelis :message="message"></StarMgtDelis>
                <PlanetData :message="message"></PlanetData>
            </el-tab-pane>
            <el-tab-pane label="主题列表" name="dynamicList">
                <StarMgtDelis :message="message"></StarMgtDelis>
                <DynamicList :message="message"></DynamicList>
            </el-tab-pane> 
        </el-tabs>

    </div>

</template>

<script>
import StarMgtDelis from './star/starMgtDelis.vue'
import MemberList from './member/MemberList.vue'
import PlanetNotes from './star/PlanetNotes.vue'
import PlanetData from './star/PlanetData.vue'
import DynamicList from './member/DynamicList.vue'

import {getStarInfo} from '@/api/starMgtApi' // 引入星球管理 api 资源文件
import {getCookie} from '@/common/js/tools' // 引入 tools 库
import Loading from 'base/loading/loading' // 引入 loading 组件
import {mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery' // 引入 jquery 组件


export default {
    name: "StarMgtList",
    data(){
        return {
            token: getCookie('token'), // token
            sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
            innerid: this.$route.query.innerid, // 星球编号
            active: this.$route.query.type,
            message: {}
        }
    },
    methods: {
        handleClick(tab,envent){
            console.log(tab,event);
        }
    },
    mounted() {
        let data = {
            LoginToken: this.token,
            innerid: this.innerid
        }
        getStarInfo({
            data:data,
            success:data=>{
                this.message = data.data;
                console.log(data)
            },
            error:data=>{
                console.log(data)
            }
        })
    },
    components:{
        StarMgtDelis,
        MemberList,
        PlanetNotes,
        PlanetData,
        DynamicList
    }
}
</script>

<style lang="scss">
    @import "~common/scss/starmgt";

    .starMgtList {

    }
</style>
